import { Lang } from "../types";

export function formatCurrency(amount: number, currency = "EUR", lang = Lang.SK): string {
	return new Intl.NumberFormat(lang, { style: "currency", currency }).format(amount);
}
